import { List } from 'foundations-components/transitional/components/List';
import { filters } from '../../publicCatalogDropdownConstants';
import { sortOptions, getSerializedOptions } from '../../publicCatalogDropdownHooks';
import MenuOption from './MenuOption';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SubMenuContent = ({
  filtersData,
  filterName,
  subMenuName
}) => {
  const filter = filters[filterName];
  const {
    marketingOptionsPresent,
    salesOptionsPresent,
    serviceOptionsPresent
  } = getSerializedOptions(filterName, filtersData[filter.apiKey]);
  let optionsToRender = null;
  if (subMenuName === filter.marketingSubMenuName) {
    optionsToRender = marketingOptionsPresent;
  } else if (subMenuName === filter.salesSubMenuName) {
    optionsToRender = salesOptionsPresent;
  } else if (subMenuName === filter.serviceSubMenuName) {
    optionsToRender = serviceOptionsPresent;
  }
  return /*#__PURE__*/_jsxs(List, {
    wrapChildren: true,
    children: [/*#__PURE__*/_jsx(MenuOption, {
      filterName: filterName,
      isAllOption: true,
      optionName: subMenuName
    }), optionsToRender && sortOptions(Array.from(optionsToRender)).map(optionName => /*#__PURE__*/_jsx(MenuOption, {
      filterName: filterName,
      optionName: optionName
    }, optionName))]
  });
};
export default SubMenuContent;